export default "__VITE_ASSET__RqSCkBzx__"